export default __webpack_public_path__ + "static/media/img4.f55e25df.png";